import { EwusPatient } from '@dreryk/egabinet-ewus-frontend-api';
import { Pesel } from '@dreryk/personal-external-identifier-common-api';

import { isDemo } from '@dreryk/demo-variant-frontend';

import { EwusPatientDownloadAction } from '~libs.desktop.patient-entitlement-to-medical-service';

import { downloadPersonalDataFromEwusTranslationKeys } from '../../../translations';

import { StyledEwusPatientDownloadButton } from './EwusPatientDownloadButton.styled';

type EwusPatientDownloadButtonProps = {
   readonly pesel: Pesel;
   readonly onSuccess: (ewusPatient: EwusPatient | undefined) => void;
   readonly disabled: boolean;
};

export const EwusPatientDownloadButton = (props: EwusPatientDownloadButtonProps): JSX.Element => {
   const demo = isDemo();

   return (
      <EwusPatientDownloadAction pesel={props.pesel} onSuccess={props.onSuccess}>
         {({ downloadEwusPatient }) => (
            <StyledEwusPatientDownloadButton
               testId={'downloadEwusPatient'}
               label={downloadPersonalDataFromEwusTranslationKeys.downloadFromEwus}
               onClick={downloadEwusPatient}
               blockingOperation={downloadPersonalDataFromEwusTranslationKeys.downloadingEwusPatient}
               disabled={props.disabled || demo}
            />
         )}
      </EwusPatientDownloadAction>
   );
};
